export function highlight(el, binding) {
    const value = binding.value === null ? "" : binding.value;
    if (typeof value !== 'string') {
        throw new Error("v-highlight value is a " + typeof value + ", expected String: " + JSON.stringify(value));
    }
    if (binding.modifiers.html) {
        const html = value
            .replace(/\[\[==/g, '<span class="highlight">')
            .replace(/==\]\]/g, '</span>');
        el.innerHTML = html;
    } else {
        const parts = value.split(/(\[\[==|==\]\])/);
        el.innerHTML = '';
        while (parts.length > 0) {
            let part = parts.shift();
            if (part === '[[==') {
                part = parts.shift();
                parts.shift(); // Remove end marker
                if (!part) {
                    continue;
                }
                const node = document.createElement("span");
                node.textContent = part;
                node.classList.add('highlight');
                el.appendChild(node);
            } else if (part === '==]]') {
                // Ignore
            } else {
                const node = document.createTextNode(part);
                el.appendChild(node);
            }
        }
    }
}
